import React, { useState } from 'react';
import { Card, Table, Typography, Space, Button, InputNumber, Form, message, Alert, Modal, Row, Col } from 'antd';
import { EditOutlined, HistoryOutlined, SwapOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;


const ExchangeRate = () => {
    const [rate, setRate] = useState(7.20);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [withdrawRate, setWithdrawRate] = useState(7.15);
    const [withdrawRateModalVisible, setWithdrawRateModalVisible] = useState(false);
    const [withdrawRateForm] = Form.useForm();
    const [form] = Form.useForm();

    // 模拟汇率变更记录
    const [history, setHistory] = useState([
        { key: '1', time: '2026-03-20 10:00:00', rate: 7.20, operator: 'admin' },
        { key: '2', time: '2026-02-15 09:30:00', rate: 7.15, operator: 'admin' },
        { key: '3', time: '2026-01-01 00:00:00', rate: 7.00, operator: 'system' },
    ]);

    const handleUpdate = (values) => {
        setRate(values.newRate);
        const newRecord = {
            key: Date.now().toString(),
            time: new Date().toLocaleString(),
            rate: values.newRate,
            operator: 'admin'
        };
        setHistory([newRecord, ...history]);
        setIsModalVisible(false);
        message.success('汇率已更新');
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: 24 }}>
                <Title level={4}>汇率管理</Title>
            </div>

            <Row gutter={24} style={{ marginBottom: 16 }}>
                <Col span={16}>
                    <Card title="套餐底价汇率" style={{ borderRadius: 8 }}>
                        <Alert message={<div>
                            <div>企业创建套餐售卖或赠送，需向平台支付套餐底价。海外套餐（美元）需此汇率转化为人民币结算。</div>
                            <Text type="danger" strong>此汇率值越大意味着企业向平台支付的人民币越多（平台赢利越大），反之企业支出小。</Text>
                        </div>} type="info" showIcon style={{ marginBottom: 16 }} />
                        <div style={{ textAlign: 'center', padding: '20px 0', background: '#f9f9f9', borderRadius: 8 }}>
                            <Space size={48} align="center">
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 8 }}>美元 (USD)</div>
                                    <div style={{ fontSize: 28, fontWeight: 'bold' }}>1</div>
                                </div>
                                <SwapOutlined style={{ fontSize: 20, color: '#1890ff', marginTop: 16 }} />
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 8 }}>人民币 (CNY)</div>
                                    <div style={{ fontSize: 28, fontWeight: 'bold', color: '#f5222d' }}>{rate.toFixed(4)}</div>
                                </div>
                            </Space>
                            <div style={{ marginTop: 20 }}>
                                <Button type="primary" icon={<EditOutlined />} onClick={() => { form.setFieldsValue({ newRate: rate }); setIsModalVisible(true); }}>调整当前汇率</Button>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title={<Space><HistoryOutlined />底价汇率变更记录</Space>} style={{ borderRadius: 8, height: '100%' }} bodyStyle={{ padding: 0 }}>
                        <Table dataSource={history} pagination={{ pageSize: 5 }} size="small"
                            columns={[
                                { title: '生效时间', dataIndex: 'time', key: 'time' },
                                { title: '汇率值', dataIndex: 'rate', key: 'rate', render: (val) => <Text strong>{val.toFixed(4)}</Text> },
                                { title: '操作人', dataIndex: 'operator', key: 'operator' },
                            ]}
                        />
                    </Card>
                </Col>
            </Row>

            {/* 提现结算汇率 */}
            <Row gutter={24}>
                <Col span={16}>
                    <Card title="提现结算汇率" style={{ borderRadius: 8 }}>
                        <Alert message={<div>
                            <div>提现结算汇率用于平台代收款抽佣后，流入到企业收益账户统一折算成人民币供企业进行提现结算。</div>
                            <Text type="danger" strong>此汇率值越大意味着平台向企业支出的人民币越多（平台赢利越小），反之平台支出小。</Text>
                        </div>} type="info" showIcon style={{ marginBottom: 16 }} />
                        <div style={{ textAlign: 'center', padding: '20px 0', background: '#f6ffed', borderRadius: 8 }}>
                            <Space size={48} align="center">
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 8 }}>美元 (USD)</div>
                                    <div style={{ fontSize: 28, fontWeight: 'bold' }}>1</div>
                                </div>
                                <SwapOutlined style={{ fontSize: 20, color: '#52c41a', marginTop: 16 }} />
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 8 }}>人民币 (CNY)</div>
                                    <div style={{ fontSize: 28, fontWeight: 'bold', color: '#52c41a' }}>{withdrawRate.toFixed(4)}</div>
                                </div>
                            </Space>
                            <div style={{ marginTop: 20 }}>
                                <Button type="primary" icon={<EditOutlined />} style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                    onClick={() => { withdrawRateForm.setFieldsValue({ newRate: withdrawRate }); setWithdrawRateModalVisible(true); }}
                                >调整提现汇率</Button>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title={<Space><HistoryOutlined />提现汇率变更记录</Space>} style={{ borderRadius: 8, height: '100%' }} bodyStyle={{ padding: 0 }}>
                        <Table dataSource={[
                            { key: 'w1', time: '2026-03-01 10:30:00', rate: 7.15, operator: 'admin' },
                            { key: 'w2', time: '2026-01-15 14:20:00', rate: 7.10, operator: 'admin' },
                            { key: 'w3', time: '2025-10-01 09:00:00', rate: 7.05, operator: 'system' },
                        ]} pagination={{ pageSize: 5 }} size="small"
                            columns={[
                                { title: '生效时间', dataIndex: 'time', key: 'time' },
                                { title: '汇率值', dataIndex: 'rate', key: 'rate', render: (val) => <Text strong style={{ color: '#52c41a' }}>{val.toFixed(4)}</Text> },
                                { title: '操作人', dataIndex: 'operator', key: 'operator' },
                            ]}
                        />
                    </Card>
                </Col>
            </Row>

            <Modal
                title="调整套餐汇率"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={() => form.submit()}
                destroyOnClose
            >
                <div style={{ marginBottom: 20, color: '#8c8c8c' }}>
                    请根据业务需求调整 USD 转 CNY 的结算汇率。
                </div>
                <Form form={form} layout="vertical" onFinish={handleUpdate}>
                    <Form.Item 
                        name="newRate" 
                        label="新汇率 (1 USD = ? CNY)" 
                        rules={[{ required: true, message: '请输入新的汇率值' }]}
                    >
                        <InputNumber 
                            style={{ width: '100%' }} 
                            precision={4} 
                            min={0.0001} 
                            placeholder="请输入汇率，如 7.2345"
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal title="调整提现结算汇率" open={withdrawRateModalVisible}
                onCancel={() => setWithdrawRateModalVisible(false)}
                onOk={() => withdrawRateForm.submit()}
                destroyOnClose
            >
                <div style={{ marginBottom: 20, color: '#8c8c8c' }}>用于企业收益账户提现时，将美元收益折算为人民币。</div>
                <Form form={withdrawRateForm} layout="vertical" onFinish={(v) => { setWithdrawRate(v.newRate); setWithdrawRateModalVisible(false); message.success('提现结算汇率已更新'); }}>
                    <Form.Item name="newRate" label="新汇率 (1 USD = ? CNY)" rules={[{ required: true, message: '请输入汇率' }]}>
                        <InputNumber style={{ width: '100%' }} precision={4} min={0.0001} placeholder="请输入汇率，如 7.1500" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ExchangeRate;
